class ProductPage {
    constructor() {
        this.variants = window.productVariants || [];
        this.mainSwiper = null;
        this.thumbSwiper = null;
        this.variantInput = document.getElementById('selected-variant-id');
        this.qtyInput = document.getElementById('Quantity');
        this.salePrice = document.querySelector('.m-product-sale-price');
        this.comparePrice = document.querySelector('.m-product-compare-price');
        this.init();
    }

    init() {
        this.initSwiper();
        this.bindEvents();
    }

    initSwiper() {
        this.thumbSwiper = new Swiper(".ProductBanner1", {
            slidesPerView: 4,
            spaceBetween: 10,
            watchSlidesProgress: true,
            freeMode: true,
            navigation: {
                nextEl: ".ProductBanner1-next",
                prevEl: ".ProductBanner1-prev"
            }
        });

        this.mainSwiper = new Swiper(".ProductBanner2", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".ProductBanner2-next",
                prevEl: ".ProductBanner2-prev"
            },
            thumbs: {
                swiper: this.thumbSwiper
            }
        });
    }

    bindEvents() {
        document.addEventListener("change", (e) => {
            if (e.target.matches('.product-option input')) {
                this.changeVariant(e.target);
            }
        });

        qtyPlusBtn?.addEventListener('click', () => {
            this.qtyInput.value = (+this.qtyInput.value || 1) + 1;
        });

        qtyMinusBtn?.addEventListener('click', () => {
            this.qtyInput.value = Math.max(1, (+this.qtyInput.value || 1) - 1);
        });

        addToCartBtn?.addEventListener('click', (e) => this.addToCart(e));

        document.querySelectorAll('.accordion-header').forEach(header => {
            header.addEventListener('click', () => {
                header.parentElement.classList.toggle('active');
            });
        });
    }

    changeVariant(input) {
        const position = input.dataset.position - 1;
        const selectedLabel = document.getElementById(`option-value-${position}`);

        if (selectedLabel) {
            selectedLabel.textContent = input.value;
        }

        const selectedOptions = [...document.querySelectorAll('.product-option input:checked')].map(el => el.value);
        const variant = this.variants.find(v => selectedOptions.every((opt, i) => v[`option${i + 1}`] === opt));

        if (!variant) return;

        document.getElementById('selected-variant-id').value = variant.id;
        this.updatePrice(variant);
        this.changeImage(variant);
    }

    updatePrice(variant) {
        if (this.salePrice) {
            this.salePrice.innerHTML = `Rs. ${(variant.price / 100).toFixed(2)}`;
        }
        if (!this.comparePrice) return;

        const wrapper = this.comparePrice.parentElement;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            wrapper.style.display = "block";
            this.comparePrice.innerHTML = `₹${(variant.compare_at_price / 100).toFixed(2)}`;
        } else {
            wrapper.style.display = "none";
        }
    }

    changeImage(variant) {
        const image = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
        if (!image) return;

        const slides = document.querySelectorAll('.ProductBanner2 .swiper-slide img');
        const index = [...slides].findIndex(img => {
            return img.src
            .split('?')[0]
            .includes(
                image
                .split('/')
                .pop()
                .split('?')[0]
            );
        });
        if (index >= 0) {
            this.mainSwiper.slideTo(index);
            this.thumbSwiper.slideTo(index);
        }
    }

    async addToCart(e) {
        e.preventDefault();

        const variantId = +this.variantInput.value;
        if (!variantId) {
            alert("Select Variant");
            return;
        }

        const quantity = +this.qtyInput.value || 1;
        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type':
                    'application/json',
                    'Accept':
                    'application/json'
                },

                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity
                    }]
                })
            });
            window.location.href = "/cart";
        } catch (err) {
            console.error("Cart Error", err);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new ProductPage();
});